// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { Progress, ProgressBar } from './styles';


const YAProgress = (props) => {
  return (
    <Progress {...props}>
      <ProgressBar role="progressbar" aria-valuenow="25"></ProgressBar>
    </Progress>
  )

}
export default YAProgress;